// Footer line GSAP animation
window.addEventListener("load", function () {
  if (window.gsap) {
    var wraps = document.querySelectorAll(".footer__line-wrap");
    wraps.forEach(function (wrap) {
      gsap.set(wrap, { xPercent: 0 });
      gsap.to(wrap, {
        xPercent: -100,
        duration: 12,
        ease: "linear",
        repeat: -1,
        onRepeat: function () {
          gsap.set(wrap, { xPercent: 0 });
        },
      });
    });
  }
});
